// pass an array of routes to render a component
export default (Component, routes = []) =>
  routes.reduce((acc, curr) => ({ ...acc, [curr]: Component }), {});
